import React from 'react';

function FilterResultsSummary({ label, count, children }) {
  return (
    <div className="summary filter-results-summary">
      <strong>
        {label}: <span>{count}</span>
      </strong>
      {children}
    </div>
  );
}

export default FilterResultsSummary;
